import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const DiplomePagination = ({ currentPage, totalPages, itemsPerPage, onPageChange, onItemsPerPageChange }) => {
    if (totalPages <= 1) return null;

    return (
        <div className="mt-6 flex justify-between items-center">
            <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-700">Afficher</span>
                <select
                    value={itemsPerPage}
                    onChange={onItemsPerPageChange}
                    className="border border-gray-300 rounded-md py-1 px-2 text-sm"
                >
                    <option value={6}>6</option>
                    <option value={9}>9</option>
                    <option value={12}>12</option>
                    <option value={24}>24</option>
                </select>
                <span className="text-sm text-gray-700">par page</span>
            </div>

            <div className="flex items-center space-x-2">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`p-2 rounded-md ${currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-100'}`}
                >
                    <ChevronLeft size={16} />
                </button>

                <span className="text-sm text-gray-700">
                    Page {currentPage} sur {totalPages}
                </span>

                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`p-2 rounded-md ${currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-100'}`}
                >
                    <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );
};

export default DiplomePagination;
